<template>
  <b-modal
    id="modalLookupTransaction"
    centered
    title="Lookup Transaction"
    title-class="font-18"
    size="lg"
    @hide="resetForm"
  >
    <div class="mb-3">
      <label for="transaction_id" class="form-label">Transaction ID</label>
      <b-form-input
        id="transaction_id"
        v-model="transactionId"
        :disabled="loading"
        placeholder="Digite o Transaction ID"
        type="text"
        :state="errorsForm.transaction_id ? false : null"
      />
      <b-form-invalid-feedback v-if="errorsForm.transaction_id">
        {{ errorsForm.transaction_id }}
      </b-form-invalid-feedback>
    </div>

    <div v-if="loading" class="text-center py-3">
      <b-spinner small />
      <span class="ml-2">Consultando transação...</span>
    </div>

    <div v-if="resultJson" class="mb-0">
      <h6 id="lookup-result-heading" class="form-label mb-2">Resultado</h6>
      <pre
        id="lookup-result"
        class="lookup-result"
        aria-labelledby="lookup-result-heading"
      >{{ resultJson }}</pre>
    </div>

    <template v-slot:modal-footer="{ cancel }">
      <div class="d-flex justify-content-around w-100">
        <b-button @click="cancel">Fechar</b-button>
        <b-button variant="success" :disabled="loading" @click="submitData">
          Consultar
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import OperationsService from '@services/resources/OperationsService';

const service = OperationsService.build();

export default {
  name: 'modalLookupTransaction',
  data() {
    return {
      requestGeneration: 0,
      transactionId: '',
      errorsForm: {},
      loading: false,
      resultJson: '',
    };
  },
  methods: {
    validateFields() {
      this.errorsForm = {};

      if (!this.transactionId.trim()) {
        this.errorsForm.transaction_id = 'O campo Transaction ID é obrigatório.';
      }

      return Object.keys(this.errorsForm).length === 0;
    },
    async submitData() {
      this.resultJson = '';

      if (!this.validateFields()) return;

      const requestGeneration = ++this.requestGeneration;
      this.loading = true;

      try {
        const query = new URLSearchParams({
          transaction_id: this.transactionId.trim(),
        }).toString();

        const response = await service.get(`lookup-transaction?${query}`);
        if (requestGeneration !== this.requestGeneration) return;

        this.resultJson = JSON.stringify(response, null, 2);

        this.$bvToast.toast('Consulta realizada com sucesso.', {
          title: 'Sucesso',
          variant: 'success',
          solid: true,
        });
      } catch (error) {
        if (requestGeneration !== this.requestGeneration) return;

        if (error.response && error.response.data !== undefined) {
          this.resultJson = JSON.stringify(error.response.data, null, 2);
        }
      } finally {
        if (requestGeneration === this.requestGeneration) {
          this.loading = false;
        }
      }
    },
    resetForm() {
      this.requestGeneration += 1;
      this.transactionId = '';
      this.errorsForm = {};
      this.loading = false;
      this.resultJson = '';
    },
  },
};
</script>

<style scoped>
.lookup-result {
  max-height: 400px;
  overflow: auto;
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 12px;
  font-size: 12px;
  margin-bottom: 0;
}
</style>
